'use client'

import ColoredScreen from '@snowball-tech/common/components/ColoredScreen'
import useLogger from '@snowball-tech/common/hooks/useLogger'
import ImageOopsSnowie from '@snowball-tech/common/images/OopsSnowie.png'
import { Button } from '@snowball-tech/fractal/dist/src/components/Button'
import { Typography } from '@snowball-tech/fractal/dist/src/components/Typography'
import Image from 'next/image'

import { useEffect } from 'react'

import '@/styles/global.css'

export default function GlobalError({
  error,
  reset,
}: {
  error: { digest?: string } & Error
  reset: () => void
}) {
  const logger = useLogger()

  useEffect(() => {
    logger.error(
      `An error occurred at the global level of the application: ${error.message}`,
      {},
      error,
    )
  }, [error, logger])

  const handleReset = () => {
    reset()
  }

  return (
    <html className="font-family-normal" lang="fr">
      <body className="bg-light" suppressHydrationWarning>
        <ColoredScreen withBlock={false}>
          <div className="flex flex-col items-center gap-4 text-center">
            <Image
              alt=""
              className="size-[320px]"
              priority
              src={ImageOopsSnowie}
            />

            <Typography variant="display-1">
              Oh là là, c’est gênant...
            </Typography>

            <Typography variant="heading-2">
              Quelque chose d’inattendu est arrivé !
            </Typography>

            <Button
              label="Réessayer 🤞"
              variant="display"
              onClick={handleReset}
            />
          </div>
        </ColoredScreen>
      </body>
    </html>
  )
}
